
import { Button, CloseButton, Drawer, Portal, Container, Flex, Menu, VStack, Avatar, Text } from "@chakra-ui/react"
import { memo, use, useState } from "react"
import { useApp } from "contexts/app";
import { useAuth } from "contexts/auth";
import { useNavigate } from "react-router";
import GuestMenu from "./GuestMenu";
import UserMenu from "./UserMenu";

const MenuLeft = () => {

   
    const { user } = useAuth();
  
   
    if(user){
        return <UserMenu></UserMenu>
    }
    return <GuestMenu></GuestMenu>
}


export default memo(MenuLeft)